import * as React from "react";
import { Table } from 'reactstrap';
import { BankDetailConstants as Constants } from "../constants";

interface AccountingTable2CProps {
    headers : string[], 
    data: any,
    totalLabel : string,
    totalAmount : string
}

interface AccountingTable2CState {
} 

class AccountingTable2C extends React.Component<AccountingTable2CProps, AccountingTable2CState> {
    // eslint-disable-next-line
    constructor(props: AccountingTable2CProps) {
        // eslint-disable-next-line
        super(props);
    }

    formatAmount( amount : string ){
        amount = amount || "0"
        let dollarAmount : string = amount;
        if( amount !== "\u00A0" )
        {
            let numAmout = parseInt(amount); 
            let preN = ""; let postN = "";
            if( numAmout < 0 ) 
            {
                numAmout = Math.abs(numAmout);
                preN = "(";
                postN = ")";
            }
            dollarAmount = preN + numAmout.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + postN;
        }
        return dollarAmount;
    }

    render() {
        const rows : any = this.props.data.map((row : any, key : any) =>
            <tr key={key} className={row.className} role={row.label === Constants.FILLER ? 'presentation' : "" } >
                <th scope="row">{row.label}{row.link !== "" ? <sup><a href={"#details" + row.link}>{"(" + row.link +")"}</a></sup> : "" }</th>
                <td>{key === 0 || ( row.label !== Constants.FILLER && ( key === 5 || key === 6) ) ? "$ " : ""}{this.formatAmount(row.amount)}</td>
            </tr>
        );

        const hdr : any= this.props.headers[0] === 'Assets' ? <sup><a href={"#details1"}>(1)</a></sup> : null;
        return (
            <Table className="acctTable">
                <thead>
                    <tr>
                        <th>{this.props.headers[0]}{hdr} </th>
                        <th>{this.props.headers[1]}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                    <tr role="presentation"><td>&nbsp;</td><td>&nbsp;</td></tr>
                    <tr className="totalSumRow" ><th scope="row">{this.props.totalLabel}</th><td>${this.formatAmount(this.props.totalAmount)}</td></tr>
                </tbody>
            </Table>
        );
    }
}

export default AccountingTable2C;